import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import Sitemap from "routes/sitemap";
import LoadingWrapper from "../../../components/Loading/LoadingWrapper";
import useAPI from "../../../hooks/useAPI";
import { GlobalQueries } from "../../../hooks/useRefreshQuery";
import ProfilePage from "../ProfilePage";
import scss from "./DebtPage.module.scss";
import { useTranslation } from "react-i18next";
import Empty from "components/Empty/Empty";

const DebtPage = () => {
    const { t } = useTranslation();
    const api = useAPI();
    const apiPath = "/profile/company/debt";

    // Load all data
    const { data, isLoading } = useQuery([GlobalQueries.Profile.MyProfile], () => api.get(apiPath));

    const { data: config } = useQuery(["debtConfig"], () => api.get("/options/profile-page/company-analytics-data/config"));

    // Local state for the debt
    const [debt, setDebt] = useState();
    useEffect(() => {
        setDebt(data);
    }, [data, setDebt]);

    const creditLimit = debt?.credit_limit == null || !Number.isFinite(Number(debt.credit_limit)) || Number(debt.credit_limit) === 0
        ? "0.00"
        : new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(Number(debt.credit_limit));

    return (
        <ProfilePage>
            <h4 className={scss.title}>{t("debt_profile-default-title")}</h4>
            {config && config?.active !== "1" && <Empty message={t("global-module_locked-title")} />}

            <LoadingWrapper isLoading={isLoading}>
                {debt && config?.active === "1" && (
                    <div className={scss.content}>
                        <p className={scss.subtitle}>{t("debt_profile-default-subtitle")}:</p>
                        <div className={scss.metrics}>
                            <article className={scss.metric}>
                                <span className={scss.metricIcon} aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <rect x="3.5" y="5.5" width="17" height="15" rx="2" stroke="currentColor" strokeWidth="1.6" />
                                        <path d="M7.5 3.5v4M16.5 3.5v4M3.5 10h17M8 15h3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                    </svg>
                                </span>
                                <div>
                                    <p className={scss.metricLabel}>{t("debt_profile-default-Currency")}</p>
                                    <p className={scss.metricValue}>{debt.debt_days ?? 0} <span>{t("debt_profile-default-days")}</span></p>
                                </div>
                            </article>
                            <article className={scss.metric}>
                                <span className={scss.metricIcon} aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none">
                                        <rect x="3.5" y="6" width="17" height="13" rx="2" stroke="currentColor" strokeWidth="1.6" />
                                        <path d="M3.5 9.5h17M7 4h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                                        <circle cx="16.5" cy="14.5" r="1" fill="currentColor" />
                                    </svg>
                                </span>
                                <div>
                                    <p className={scss.metricLabel}>{t("debt_profile-default-credit_limit")}</p>
                                    <p className={scss.metricValue}>{creditLimit} <span>RSD</span></p>
                                </div>
                            </article>
                        </div>
                        <div className={scss.contactCard}>
                            <div>
                                <p className={scss.contactTitle}>{t("debt_profile-default-question")}</p>
                                <p className={scss.contactText}>{t("debt_profile-default-contact_us_text")}</p>
                            </div>
                            <Link className={scss.contactButton} to={Sitemap.contact._}>{t("debt_profile-default-contact_us_button")}</Link>
                        </div>
                    </div>
                )}
            </LoadingWrapper>
        </ProfilePage>
    );
};

export default DebtPage;
